import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function StarCircleIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.5289 2 12 2ZM15.5289 16.8533L12 14.8889L8.48 16.8533L9.25333 12.8978L6.29333 10.1422L10.3022 9.66222L12 6L13.7067 9.66222L17.7067 10.1422L14.7556 12.8978L15.5289 16.8533Z"
				fill="currentColor"
			/>
		</svg>
	);
}

StarCircleIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default StarCircleIcon;
